<div class="footer">
  <div>
    <div>{{constants.Footer["All-Rights-Reserved1"]}}</div>
    <div>{{constants.Footer["All-Rights-Reserved2"]}}</div>
  </div>
</div>